var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sw-js-blob-svg",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sw-gradient",
    x1: 0,
    x2: 1,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop1",
    stopColor: "rgba(35, 139, 230, 1)",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop2",
    stopColor: "rgba(235, 243, 253, 1)",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M18.3,-9.8C24.3,-0.3,29.9,10.1,26.8,13.8C23.7,17.5,11.9,14.5,-0.8,15C-13.5,15.5,-27.1,19.5,-30.4,15.6C-33.7,11.8,-26.8,0.1,-20.1,-9.8C-13.3,-19.7,-6.6,-28,-0.2,-27.8C6.2,-27.7,12.4,-19.2,18.3,-9.8Z",
    width: "100%",
    height: "100%",
    transform: "translate(50 50)",
    strokeWidth: 6,
    style: {
      transition: "0.3s"
    },
    stroke: "url(#sw-gradient)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.33bbe1bd4ce35432bd73c1889dd3b919.svg";
export { ForwardRef as ReactComponent };